import { SessionHelper } from "../helpers/sessionHelper";
import store from "../store/store";
import type { SessionType } from "../types/userType";
import { SessionStatus } from "../utils/const";
export default class UserLogic {
  /**
   * log out user
   */
  static logout() {
    SessionHelper.clearToken();
  }

  /**
   * update session
   */
  static sessionUpdate(session: SessionType) {
    if (session.status.toUpperCase() === SessionStatus.FINISHED) {
      this.logout();
      window.location.reload();
    } else if (session.status.toUpperCase() === SessionStatus.EXPIRED) {
      store.dispatch.sessionModel.setUserSession(session);
    }
  }
}
